import styled, { css } from 'styled-components';
import { isTransparentColor } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { useLayoutGap } from '../layout';
import { useSocialFeedSettings } from '../utils';
import {
  useHeaderData,
  useHeaderDisplayLogic,
  useHeaderResponsive
} from './helpers';
import { Desktop, Mobile } from './layout';

export function WidgetHeader() {
  const {
    widgetTitle,
    widgetTitleTitle,
    widgetTitleCaption,
    headerBackgroundColor,
    headerCornerRadius,
    displayHeader
  } = useSocialFeedSettings();
  const userData = useHeaderData();
  const { isMobile, headerContainerRef } = useHeaderResponsive();
  const { hasAnyVisibleElement } = useHeaderDisplayLogic();
  const { gap: marginBottom } = useLayoutGap();

  const Layout = isMobile ? Mobile : Desktop;

  const isWidgetTitleActive =
    widgetTitle && (!!widgetTitleTitle?.trim() || !!widgetTitleCaption?.trim());

  const isHeaderAvailable =
    displayHeader && Object.keys(userData).length > 0 && hasAnyVisibleElement;

  if (!isHeaderAvailable) {
    return null;
  }

  return (
    <Container
      ref={headerContainerRef}
      role="banner"
      aria-label="Social media profile header"
      $backgroundColor={headerBackgroundColor}
      $cornerRadius={headerCornerRadius}
      $isMobile={isMobile}
      $isWidgetTitleActive={isWidgetTitleActive}
      $marginBottom={marginBottom}
    >
      <Layout />
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'header',
    element: 'container'
  })
})<{
  $isWidgetTitleActive: boolean;
  $marginBottom: number;
  $backgroundColor?: string;
  $cornerRadius?: number;
  $isMobile?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  margin-bottom: ${({ $marginBottom }) => `${$marginBottom}px`};

  ${({ $backgroundColor, $isWidgetTitleActive }) =>
    isTransparentColor($backgroundColor) &&
    css`
      padding-bottom: 16px;

      ${$isWidgetTitleActive &&
      css`
        padding-top: 16px;
      `}
    `}

  ${({ $backgroundColor, $cornerRadius, $marginBottom }) =>
    !isTransparentColor($backgroundColor) &&
    css`
      padding: 16px;

      ${$cornerRadius &&
      css`
        border-radius: ${$marginBottom
          ? `${$cornerRadius}px`
          : `${$cornerRadius}px ${$cornerRadius}px 0px 0px`};
      `}
    `}
`;
